import { CorporateProfile } from '../model/corporate-profile';
import { ProfessionalProfile } from '../model/professional-profile';
import * as _ from 'lodash-es';
export class ProfileBuilder {
    static buildProfile(data) {
        let profile;
        if (data.type === 'corporate')
            profile = this.buildCorporateProfile(data);
        else
            profile = new ProfessionalProfile();
        profile.id = data.profile_id;
        profile.monthlyInvoice = data.monthly_invoice;
        profile.name = data.invoice_name;
        profile.nif = data.invoice_nif;
        profile.email = data.invoice_email;
        profile.address = data.invoice_address;
        profile.city = data.invoice_city;
        profile.state = data.invoice_state;
        profile.zip = data.invoice_zip;
        profile.invoice_country = data.invoice_country;
        profile.use_points_by_default = data.use_points_by_default;
        return profile;
    }
    static buildCorporateProfile(data) {
        let profile = new CorporateProfile();
        profile.companyId = data.company_id;
        profile.costCenterId = data.costcenter_id;
        profile.invoicePerCostCenter = data.invoice_per_costcenter;
        profile.sendReservationCopy = data.send_reservation_copy;
        profile.sendInvoiceCopy = data.send_invoice_copy;
        profile.enableBookingRecords = data.enable_booking_records;
        profile.block_premium_for_this_profile = data.block_premium_for_this_profile;
        profile.use_points_by_default = data.use_points_by_default;
        if (data.rights) {
            profile.role = data.rights.role;
            let permissions = [];
            _.forEach(data.rights.permissions, (value, perm) => {
                if (value)
                    permissions.push(perm);
            });
            profile.permissions = permissions;
        }
        return profile;
    }
    static buildProfessionalProfilePayload(profile) {
        return {
            monthly_invoice: profile.monthlyInvoice,
            invoice_name: profile.name,
            invoice_nif: profile.nif,
            invoice_email: profile.email,
            invoice_address: profile.address,
            invoice_city: profile.city,
            invoice_state: profile.state,
            invoice_zip: profile.zip,
            invoice_country: profile.invoice_country,
            default_invoice_profile: profile.default,
            use_points_by_default: profile.use_points_by_default
        };
    }
    static buildCorporateProfilePayload(profile) {
        return {
            use_points_by_default: profile.use_points_by_default
        };
    }
}
//# sourceMappingURL=profile-builder.js.map